export const isNullOrUndefined = (value: unknown) => value === null || value === undefined;
export const iconSize = (size = 20) => ({ width: size, height: size });
export const getCleanNumberInputValue = (value: any) =>
  (!value.length && typeof value !== 'number') || Number.isNaN(+value) ? null : parseFloat(value);
export const getMitreLink = (techniqueId: string) => `https://attack.mitre.org/techniques/${techniqueId}`;
